export enum OrganizationTypes {
    CommunityGroup = 'COMMUNITYGROUP',
    PatientGroup = 'GROUP',
    Facility = 'FACILITY',
    Clinic = 'CLINIC',
    OpenPod = 'openPod',
    School = 'SCHOOL',
    SubOrg = 'SUB-ORG',
    VA = 'VA',

    STATE = 'STATE',
    COUNTY = 'COUNTY',
    DISTRICT = 'DISTRICT',
    SCHOOL = 'SCHOOL',
    CLINIC = 'CLINIC',
}

export const organizationTypesArray = [
    {
        id: "STATE",
        name: "State"
    },
    {
        id: "COUNTY",
        name: "County"
    },
    {
        id: "DISTRICT",
        name: "District"
    },
    {
        id: "SCHOOL",
        name: "School"
    }

] as const;

export type IOrganizationTypes = typeof organizationTypesArray[number];
